import { createAsyncThunk } from "@reduxjs/toolkit";
import config from "../../../config";
import axiosClient from "../../../common/api/request";

// A 500 or a body that is not an object reads as the request's own message,
// the same rule the report downloads use for their error toasts.
const toRejectValue = (error) =>
  error?.response?.data &&
  typeof error.response.data === "object" &&
  error?.response?.status !== 500
    ? error.response.data
    : { Error: error?.message };

const createPaymentMethodsThunk = (endpoint) =>
  createAsyncThunk(
    `paymentMethodsV3/${endpoint}`,
    async (params, { rejectWithValue }) => {
      try {
        return await axiosClient.get(
          `${config.API_URL_V3}/payment_methods/${endpoint}/`,
          { params }
        );
      } catch (error) {
        return rejectWithValue(toRejectValue(error));
      }
    }
  );

export const getPaymentMethodsV3Ranking = createPaymentMethodsThunk("ranking");
export const getPaymentMethodsV3Share = createPaymentMethodsThunk("share");
export const getPaymentMethodsV3Summary = createPaymentMethodsThunk("summary");
export const getPaymentMethodsV3Daily = createPaymentMethodsThunk("daily");
export const getPaymentMethodsV3Details = createPaymentMethodsThunk("details");
export const getPaymentMethodsV3Insights = createPaymentMethodsThunk("insights");
export const getPaymentMethodsV3InsightsDaily =
  createPaymentMethodsThunk("insights/daily");
export const getPaymentMethodsV3InsightsBreakdowns = createPaymentMethodsThunk(
  "insights/breakdowns"
);
export const getPaymentMethodsV3InsightsCustomers =
  createPaymentMethodsThunk("insights/customers");
export const downloadPaymentMethodsV3 = createPaymentMethodsThunk("download");
